import { getRandomDefaultImage } from '@/lib/utils/getRandomImage';

import type { AdvancedImage } from '@/lib/api/types';

export const createImage = (img?: string | AdvancedImage): AdvancedImage => {
  if (!img) {
    return {
      landscape: {
        url: getRandomDefaultImage('video'),
        path: '',
        root: '',
      },
      portrait: {
        url: getRandomDefaultImage('video'),
        path: '',
        root: '',
      },
    };
  }
  if (typeof img === 'string') {
    return {
      landscape: {
        url: img,
        path: '',
        root: '',
      },
      portrait: { url: img, path: '', root: '' },
    };
  }
  const { landscape, portrait } = img;
  const hasLandscape = Boolean(landscape?.url);
  const hasPortrait = Boolean(portrait?.url);
  const finalLandscape = hasLandscape
    ? landscape!
    : hasPortrait
      ? { ...portrait! }
      : { url: getRandomDefaultImage('video'), path: '', root: '' };

  const finalPortrait = hasPortrait
    ? portrait!
    : hasLandscape
      ? { ...landscape! }
      : { url: getRandomDefaultImage('video'), path: '', root: '' };

  return {
    landscape: finalLandscape,
    portrait: finalPortrait,
  };
};
